export enum UnidadeDeMedida {
  dia = "Dia",
  semana = "Semana",
  mes = "Mês",
  ano = "Ano",
}
